<template>

    <div class="frame" :style="{'padding': $mq === 'phone' ? '0.7rem' : '2rem'}"> 

        <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/440252988?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow=" fullscreen" allowfullscreen></iframe></div>

    </div>
</template>

<script>
export default {

}
</script>

<style>

@import 'main.scss';

</style>